/* MHT2709-D (demande de Jules 27/09) : toucher la photo d'une carte produit montre la 2e photo (le dos).
   Telephone : 1er toucher sur la photo = 2e photo ; 2e toucher = ouvre la fiche. Ordinateur : survol (Dawn).
   Ne concerne que les cartes qui ont une 2e photo. Retirer = enlever la ligne mht-photo-dos.js de snippets/mht-quickadd-assets.liquid. */
(function () {
  if (window.__mhtDos) return;
  window.__mhtDos = 1;

  var fleche = String.fromCharCode(8635);
  var css =
    '.card-wrapper .media.media--hover-effect>img+img{opacity:0;transition:opacity .25s ease}' +
    '.card-wrapper.mht-dos .media.media--hover-effect>img:first-child:not(:only-child){opacity:0}' +
    '.card-wrapper.mht-dos .media.media--hover-effect>img+img{opacity:1}' +
    '.card-wrapper.mht-2p .card__media::before{content:"' + fleche + ' 2 photos";position:absolute;top:8px;right:8px;z-index:2;' +
    'background:rgba(255,255,255,.92);color:#121212;border:1px solid #e2e2e2;border-radius:999px;padding:3px 8px;' +
    'font-size:10.5px;font-weight:700;line-height:1.2;pointer-events:none}' +
    '.card-wrapper.mht-dos .card__media::after{content:"Touchez encore pour ouvrir";position:absolute;left:50%;bottom:8px;' +
    'transform:translateX(-50%);z-index:2;background:rgba(18,18,18,.78);color:#fff;border-radius:999px;padding:4px 10px;' +
    'font-size:11px;font-weight:600;line-height:1.2;white-space:nowrap;pointer-events:none}';
  var st = document.createElement('style');
  st.setAttribute('data-mht', 'MHT2709-D');
  st.appendChild(document.createTextNode(css));
  document.head.appendChild(st);

  function media(w) {
    var m = w.querySelector('.card__media .media--hover-effect');
    return m && m.querySelectorAll('img').length > 1 ? m : null;
  }
  function mark() {
    var l = document.querySelectorAll('.card-wrapper:not(.mht-2p)');
    for (var i = 0; i < l.length; i++) if (media(l[i])) l[i].classList.add('mht-2p');
  }
  function reset(except) {
    var l = document.querySelectorAll('.card-wrapper.mht-dos');
    for (var i = 0; i < l.length; i++) if (l[i] !== except) l[i].classList.remove('mht-dos');
  }
  function isTouch(e) {
    if (e.pointerType) return e.pointerType === 'touch' || e.pointerType === 'pen';
    return !!(window.matchMedia && window.matchMedia('(hover: none)').matches);
  }

  document.addEventListener('click', function (e) {
    if (!isTouch(e)) return;
    var t = e.target;
    var w = t && t.closest ? t.closest('.card-wrapper') : null;
    if (!w) { reset(null); return; }
    var m = media(w);
    if (!m) { reset(null); return; }
    if (t.closest('button, form, input, select, .quick-add, modal-opener, product-form')) return;
    var r = m.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) return;
    if (w.classList.contains('mht-dos')) return; /* 2e toucher : on laisse ouvrir la fiche */
    e.preventDefault();
    e.stopPropagation();
    reset(w);
    w.classList.add('mht-dos');
  }, true);

  window.addEventListener('pageshow', function () { reset(null); mark(); });

  var timer = null;
  function later() { clearTimeout(timer); timer = setTimeout(mark, 200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
  if (window.MutationObserver) {
    new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
